<template>
  <div class="auth-wrapper">
    <div class="auth-panel">
      <div class="status-icon">
        <div class="icon-circle"></div>
      </div>
      <h1 class="status-code">401</h1>
      <p class="status-description">身份验证失效，请重新登录系统</p>
      <div class="status-detail">
        当前会话已超时或未授权访问本页面
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.auth-wrapper {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fbff;
}

.auth-panel {
  width: 480px;
  padding: 40px 60px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 12px 24px rgba(23, 43, 77, 0.08);
  text-align: center;
  transform: translateY(-5%);
  animation: panelEnter 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.status-icon {
  margin-bottom: 24px;
  .icon-circle {
    width: 80px;
    height: 80px;
    margin: 0 auto;
    background: #e8f1fd;
    border-radius: 50%;
    position: relative;
    &::after {
      content: '⚠';
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 36px;
      color: #3d7eff;
    }
  }
}

.status-code {
  font-size: 48px;
  color: #2c3e50;
  margin-bottom: 16px;
  font-weight: 600;
  letter-spacing: 2px;
}

.status-description {
  font-size: 18px;
  color: #5e6c84;
  margin-bottom: 8px;
  line-height: 1.5;
}

.status-detail {
  font-size: 14px;
  color: #97a0af;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebecf0;
}

@keyframes panelEnter {
  0% {
    opacity: 0;
    transform: translateY(20px) scale(0.98);
  }
  100% {
    opacity: 1;
    transform: translateY(-5%) scale(1);
  }
}
</style>

<script>
export default {
  methods: {
    goHome() {
      this.$router.push('/');
    }
  }
}
</script>

<style lang="scss" scoped>
.error-container {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f6fa;
}

.error-content {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
}

.error-image {
  width: 300px;
  margin-bottom: 30px;
}

.error-code {
  font-size: 80px;
  color: #2d8cf0;
  font-weight: bold;
  margin-bottom: 20px;
}

.error-message {
  font-size: 18px;
  color: #666;
  margin-bottom: 30px;
}

.back-btn {
  padding: 12px 35px;
  background: #2d8cf0;
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: #57a3f3;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(45,140,240,0.3);
  }
}
</style>